/* istanbul ignore file */
import React from 'react';
import { EnumDropdown, DefaultInputPropTypes } from 'framework/form';
import { INVOICE_STATUSES_OPTIONS } from 'domain/finance/invoice/useInvoiceService';

const InvoiceStatusDropdown = (props: DefaultInputPropTypes<string>) => {
  return <EnumDropdown options={INVOICE_STATUSES_OPTIONS} label="Status" {...props} />;
};

export default InvoiceStatusDropdown;
